class Product {
    constructor() {
        this.id = null
        this.similar_product = null
        this.external_id = ''
        this.external_common_id = ''
        this.name = ''
        this.reference_number = ''
        this.brand = ''
        this.voltage = ''
        this.color = ''
        this.status = ''
        this.parent = ''
        this.master_box_type = ''
        this.master_box_size = ''
        this.datetime_created = ''
        this.datetime_updated = ''
        this.cubage_id = ''
    }

    static get fieldNames() {
        return {
            id: 'ID',
            similar_product: 'Produto Similar',
            external_id: 'ID Externo',
            external_common_id: 'ID',
            name: 'Produto',
            reference_number: 'Referência',
            brand: 'Fornecedor',
            voltage: 'Voltagem',
            color: 'Cor',
            status: 'Status',
            parent: 'Árvore de Sortimento',
            cubage_id: 'Cubagem',
            datetime_created: 'Data de Criação',
            datetime_updated: 'Data de Atualização',
            master_box_type: 'Tipo de Caixa-Master',
            master_box_size: 'Tamanho de Caixa-Master'
        }
    }

    static get fieldTypes() {
        return {
            id: 'number',
            similar_product: 'number',
            external_id: 'text',
            external_common_id: 'text',
            name: 'text',
            reference_number: 'text',
            brand: 'text',
            voltage: 'number',
            color: 'number',
            status: 'text',
            parent: 'text',
            cubage_id: 'number',
            datetime_created: 'datetime-local',
            datetime_updated: 'datetime-local'
        }
    }

    static get visibleFields() {
        return {
            id: false,
            similar_product: false,
            external_id: false,
            external_common_id: true,
            name: true,
            reference_number: true,
            brand: true,
            voltage: true,
            color: true,
            status: true,
            parent: false,
            cubage_id: true,
            datetime_created: false,
            datetime_updated: false
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            similar_product: true,
            external_id: true,
            external_common_id: true,
            reference_number: true,
            name: true,
            brand: true,
            voltage: true,
            color: true,
            status: true,
            parent: true,
            cubage_id: true,
            master_box_size: true,
            master_box_type: true
            // datetime_created: false
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            similar_product: true,
            external_id: true,
            external_common_id: true,
            reference_number: true,
            name: true,
            brand: true,
            voltage: true,
            color: true,
            status: true,
            parent: true,
            cubage_id: true,
            master_box_size: true,
            master_box_type: true
            // datetime_created: false
        }
    }

    static get status() {
        return {
            //status_all: {
            //    text: "Todos",
            //    status: "ALL"
            //},
            status_pending: {
                text: 'Candidato',
                status: 'P'
            },
            status_active: {
                text: 'Ativo',
                status: 'A'
            },
            status_discontinuing: {
                text: 'Em. Desc.',
                status: 'D'
            },
            status_out_of_line: {
                text: 'Desc.',
                status: 'O'
            },
            status_inactive: {
                text: 'Inativo',
                status: 'I'
            }
        }
    }
}

export default Product

export { Product }
